import classNames from "classnames";
import { useScreenSize } from "hooks";
import { Typography } from "components/atoms/Typography";
import { BellIcon } from "components/atoms/Icon/BellIcon";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  countSectionStyles?: string;
  count: number;
  onClick?: () => void;
}

export const NotificationSection = ({
  theme,
  countSectionStyles,
  count,
  onClick,
}: IProps) => {
  const screen = useScreenSize();
  return (
    <div className="notification-section-wrapper" onClick={onClick}>
      <div className="notification-container">
        <div className="icon-section">
          <BellIcon
            color={
              screen.width < 1024
                ? "white"
                : theme === "light"
                  ? "black"
                  : "white"
            }
          />
        </div>
        {count > 0 ? (
          <div
            className={classNames("count-section", {
              [`${countSectionStyles}`]: countSectionStyles,
            })}
          >
            <Typography
              variant="h9Medium"
              label={`${count}`}
              styles="notification-number"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
